exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#app{font-family:Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,\\\\5FAE\\8F6F\\96C5\\9ED1,Arial,sans-serif;text-align:center}.h1{font-size:20px}.h2{font-size:18px}.h3{font-size:16px}.text-regular{font-size:14px}.text-small{font-size:13px}.text-smaller{font-size:12px}.color-dark-light{color:#99a9bf}.el-row{margin-bottom:20px}.el-row:last-child{margin-bottom:0}.el-footer,.el-header{background-color:#b3c0d1;color:#333;text-align:center;line-height:60px}.el-aside{background-color:#d3dce6;line-height:200px}.el-aside,.el-main{color:#333;text-align:center}.el-main{background-color:#e9eef3;line-height:160px}body>.el-container{margin-bottom:40px}.el-container:nth-child(5) .el-aside,.el-container:nth-child(6) .el-aside{line-height:260px}.el-container:nth-child(7) .el-aside{line-height:320px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1bc7c1c7","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 136
// module chunks = 1